import type { Post } from '@/data/blogPosts';

const BlogSchema = ({ post }: { post: Post }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "image": `https://ardsdothan.com${post.image}`,
    "author": {
      "@type": "Organization",
      "name": "Ard's Plumbing & Electric"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Ard's Plumbing & Electric",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ardsdothan.com/logo.png"
      }
    },
    "datePublished": new Date(post.date).toISOString().split('T')[0],
    "dateModified": new Date(post.date).toISOString().split('T')[0],
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://ardsdothan.com/blog/${post.slug}`
    },
    "url": `https://ardsdothan.com/blog/${post.slug}`,
    "description": post.description
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default BlogSchema;